import { render } from "./WaitingListView.vue?vue&type=template&id=571e27ad"
import script from "./WaitingListView.vue?vue&type=script&lang=js"
export * from "./WaitingListView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/views/WaitingListView.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "571e27ad"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('571e27ad', __exports__)) {
    api.reload('571e27ad', __exports__)
  }
  
  module.hot.accept("./WaitingListView.vue?vue&type=template&id=571e27ad", () => {
    api.rerender('571e27ad', render)
  })

}


export default __exports__